export default [  
  {
    path: '/order/:id/pay',
    name: 'order-pay',
    component: () => import('@/views/modules/frontend/orderPay'),
    meta: {
      layout: 'frontend',     
    },    
  },

  {
    path: '/order/:id/:uid/pay/success',
    name: 'order-pay-success',
    component: () => import('@/views/modules/frontend/orderPaySuccess'),
    meta: {
      layout: 'frontend',     
    },    
  },

  {
    path: '/order/:id/:uid/pay/failed',
    name: 'order-pay-failed',
    component: () => import('@/views/modules/frontend/orderPayFailed'),
    meta: {
      layout: 'frontend',     
    },    
  },

  
  {
    path: '/about',
    name: 'about',
    component: () => import('@/views/modules/frontend/about'),
    meta: {
      layout: 'frontend',     
    },    
  },

]